(function() {
  const sizeTable = document.querySelector('.sizeTable'),
        body = document.querySelector('body'),
        closeSizeButton = document.querySelector('.sizeTable__buttonClose'),
        sizeLink = document.querySelector('.product__swatchesLink'),
        overlap = document.querySelector('.overlap');

  function openSizeTable(event) {
    sizeTable.classList.add('sizeTable--active');
    overlap.classList.add('overlap--active');
    body.classList.add('body--overflow');
  }

  function closeSizeTable() {
    sizeTable.classList.remove('sizeTable--active');
    overlap.classList.remove('overlap--active');
    body.classList.remove('body--overflow');
  }

  if (sizeLink) {
    sizeLink.addEventListener('click', (event) => {
      openSizeTable(event);
    });
  }

  if (closeSizeButton) {
    closeSizeButton.addEventListener('click', (event) => {
      closeSizeTable(event);
    });
  }
})();
